import styled from 'styled-components';

export const WistiaStyle = styled.div`
`;
